/**
 * || 0 防止 NaN
 */
export const parseToNumber = (value: string | number | undefined | null) => Number(value) || 0
